export default [
  {
    id: '0',
    name: 'Car Loan',
    type: 'autoLoan',
    current: 3500,
    starting: 24000,
  },
  {
    id: '1',
    name: 'Credit Card #1',
    type: 'creditCard',
    current: 4800,
    starting: 11400,
  },
  {
    id: '2',
    name: 'Credit Card #2',
    type: 'creditCard',
    current: 3275,
    starting: 8900,
  },
  {
    id: '3',
    name: 'Student Loan #1',
    type: 'studentLoan',
    current: 14000,
    starting: 24000,
  },
  {
    id: '4',
    name: 'Student Loan #2',
    type: 'studentLoan',
    current: 3275,
    starting: 16800,
  },
  {
    id: '5',
    name: 'Medical Bill',
    type: 'medical',
    current: 2500,
    starting: 4700,
  },
];



// WEBPACK FOOTER //
// ./src/constants/debts.js